// The automatic { type: 'isTouchDevice', value } message of docs.streampixel.io
// "Hide / unhide touch controls": true for phone and tablet browsers, false for
// desktops (a touch-screen laptop is a desktop: it has a mouse or trackpad).
//
// The user agent decides first. iPadOS 13+ Safari reports itself as a Mac
// ("Macintosh"), so a Mac UA with several touch points is an iPad. Last, a
// browser whose only pointer is coarse (no mouse or trackpad at all) counts as
// touch, which catches tablets with unusual user agents.
export function detectTouchDevice(env = {}) {
  const nav = env.navigator ?? (typeof navigator !== 'undefined' ? navigator : {});
  const matchMedia = env.matchMedia ?? (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia.bind(window) : null);
  const ua = nav.userAgent || '';
  const touchPoints = Number(nav.maxTouchPoints) || 0;

  if (/android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobi|tablet|silk|kindle/i.test(ua)) return true;
  if (/macintosh/i.test(ua) && touchPoints > 1) return true;   // iPadOS presenting as a Mac
  if (matchMedia && touchPoints > 0) {
    try {
      const coarse = matchMedia('(any-pointer: coarse)').matches;
      const fine = matchMedia('(any-pointer: fine)').matches;
      return coarse && !fine;
    } catch (_) { /* no media queries: fall through */ }
  }
  return false;
}

export const isTouchDeviceMessage = (env) => ({ type: 'isTouchDevice', value: detectTouchDevice(env) });
